<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isAddPopup ? '태스크 정의 추가' : '태스크 정의 수정'" width="600px" @close="close()">
    <div slot="content">
      <el-form :model="formData" :rules="rules" ref="taskDefForm">
        <!--  태스크 정의 설정 -->
        <el-row class="title-bar title-h4 dot-title">태스크 정의 설정</el-row>
        <el-row>
          <el-form-item label="태스크 아이디" prop="taskId">
            <el-input v-model="formData.taskId" :disabled="true"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item label="OS 종류" prop="os">
              <el-select v-model="formData.os" style="width: 100%" :disabled="!isAddPopup" @change="onSelectChange">
                <el-option v-for="(os, index) in osList" :key="`os.${index}`" :label="os.nodetypeName" :value="os.nodetypeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="공급자" prop="distributor">
              <el-select v-model="formData.distributor" style="width: 100%" :disabled="!isAddPopup">
                <el-option v-for="(distributor, index) in distributorList" :key="`distributor.${index}`" :label="distributor.nodetypeName" :value="distributor.nodetypeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15" class="mr-b15">
          <el-col :span="12">
            <el-form-item label="버전" prop="version">
              <el-select v-model="formData.version" style="width: 100%" :disabled="!isAddPopup">
                <el-option v-for="(version, index) in versionList" :key="`version.${index}`" :label="version.nodetypeName" :value="version.nodetypeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="아키텍처" prop="arch">
              <el-select v-model="formData.arch" style="width: 100%" :disabled="!isAddPopup">
                <el-option v-for="(arch, index) in archList" :key="`arch.${index}`" :label="arch.nodetypeName" :value="arch.nodetypeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 변수 설정 -->
        <el-row class="title-bar title-h4 dot-title">실행 방법</el-row>
        <el-row class="mr-b15">
          <el-form-item label="변수 이름" prop="variableId">
            <el-select v-model="formData.variableId" style="width: 100%" :disabled="!isAddPopup">
              <el-option v-for="variable in taskDefVariables" :key="variable.variableId" :label="variable.variableId" :value="variable.variableId"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
          <el-form-item>
            <span>
              <span class="el-form-item__label">정의값</span>
              <el-popover ref="varPopover" placement="left" trigger="click" width="600" :offset="40">
                <w-task-def-value-table/>
                <span slot="reference"><i class="fas fa-info-circle c-pointer"></i></span>
              </el-popover>
            </span>
            <el-input type="textarea" v-model="formData.defineValue" placeholder="정의값" :rows="10"></el-input>
          </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="saveButtonDisabled" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep, filter } from 'lodash';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import WTaskDefValueTable from '../components/TaskDefValueTable';

export default {
  name: 'WTaskDefSettingPopup',
  components: {
    WTaskDefValueTable,
  },
  props: {
    selectedTask: Object,
    selectedTaskDef: Object,
    varDefGrpList: Array,
  },
  data() {
    return {
      osList: [],
      distributorList: [],
      versionList: [],
      archList: [],
      formData: {
        taskId: '',
        os: '',
        distributor: '',
        version: '',
        arch: '',
        variableId: '',
        defineValue: '',
      },
      rules: {
        os: [
          { required: true, message: '필수 정보입니다.', trigger: 'change' },
        ],
        distributor: [
          { required: true, message: '필수 정보입니다.', trigger: 'change' },
        ],
        version: [
          { required: true, message: '필수 정보입니다.', trigger: 'change' },
        ],
        arch: [
          { required: true, message: '필수 정보입니다.', trigger: 'change' },
        ],
        variableId: [
          { required: true, validator: this.validateTaskVariable, trigger: 'change' },
        ],
      },
      nodetypeList: [],
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedTaskDef);
    },
    saveButtonDisabled() {
      return !this.isAddPopup && isEqual(this.formData, this.selectedTaskDef);
    },
    taskDefVariables() {
      if (isNil(this.selectedTask)) {
        return null;
      }
      return filter(this.varDefGrpList, (e) => e.grpId === this.selectedTask.action);
    },
  },
  methods: {
    isNil,
    open() {
      this.formData.taskId = this.selectedTask.taskId;
      if (!this.isAddPopup) {
        this.formData = cloneDeep(this.selectedTaskDef);
      } else if (!isNil(this.taskDefVariables)) {
        this.formData.variableId = this.taskDefVariables[0].variableId;
      }
      this.loadData();
      this.$nextTick(() => {
        this.$refs.slidingPopup.visible = true;
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.taskDefForm.resetFields();
      this.formData = {
        taskId: '',
        os: '',
        distributor: '',
        version: '',
        arch: '',
        variableId: '',
        defineValue: '',
      };
      this.osList = [];
      this.distributorList = [];
      this.versionList = [];
      this.archList = [];
      this.$refs.varPopover.doClose();
    },
    onSaveButton() {
      this.$refs.taskDefForm.validate().then((valid) => {
        if (valid) {
          amsSettingsApi.insertTaskDef(this.formData).then((response) => {
            const target = '태스크 정의';
            const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
            if (response.data.success) {
              this.$emit('re-load');
              this.close();
            }
            this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
          });
        }
      }).catch(() => {});
    },
    /**
     * 플랫폼 nodetype 리스트 로드
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      const me = this;
      me.osList = [];
      amsSettingsApi.getNodetypeList().then((response) => {
        if (response.data.success) {
          me.nodetypeList = response.data.data;
          me.osList = [{ orderbyIndex: 1, nodetypeId: 'all', nodetypeName: '전체' }, ...filter(me.nodetypeList, (e) => e.typeId === 'OS')];
          if (!this.isAddPopup) {
            this.setNodetypeList(me.formData.os);
          } else {
            me.formData.os = me.osList[0].nodetypeId;
            this.onSelectChange(me.osList[0].nodetypeId);
          }
        }
      });
    },
    /**
     * 플랫폼 별 리스트 설정
     * @author jeee12
     * @param  {[type]} osValue 선택한 os
     */
    setNodetypeList(osValue) {
      const me = this;
      me.distributorList = [{ orderbyIndex: 1, nodetypeId: 'all', nodetypeName: '전체' }];
      me.versionList = [{ orderbyIndex: 1, nodetypeId: 'all', nodetypeName: '전체' }];
      me.archList = [{ orderbyIndex: 1, nodetypeId: 'all', nodetypeName: '전체' }];
      me.nodetypeList.forEach((e) => {
        if (osValue !== 'all') {
          if (e.parentNodetypeId === osValue && e.typeId !== 'OS') {
            me[`${e.typeId.toLowerCase()}List`].push(e);
          }
        }
      });
    },
    /**
     * select change
     * @author jeee12
     * @param  {[type]} osValue 선택한 os
     * @return {[type]}         [description]
     */
    onSelectChange(osValue) {
      this.setNodetypeList(osValue);
      const formData = this.formData;
      [formData.distributor, formData.version, formData.arch] = ['all', 'all', 'all'];
    },
    /**
     * 태스크 정의 변수 중복체크
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateTaskVariable(rule, value, callback) {
      if (isNil(value) || value === '') {
        return callback(new Error('필수 정보입니다.'));
      }
      amsSettingsApi.checkTaskVariableIdValidation(this.formData).then((response) => {
        const isUniq = response.data.data;
        if (this.isAddPopup && !isUniq) {
          // 태스크 정의 추가시
          callback(new Error('이미 등록된 태스크 정의 변수입니다.'));
        }
        callback();
      });
      return true;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TaskSetting/popup/TaskDefSettingPopup.vue